import React, { Component } from "react";
import ReactDOM from "react-dom";
import {connect} from "react-redux";
import {firstLetterText,firstLetterSub,getIDForColor } from "../../lib/helper"
import TimeAgo from "react-timeago";
import {BrowserRouter, Link, useNavigate } from "react-router-dom";
import {pickFromQueue} from "../../actions/actions"
import SuperViseChatButton from "../buttons/SuperViseChatButton";
import { Column, Table, SortDirection, AutoSizer } from "react-virtualized";
import "react-virtualized/styles.css";
import _ from 'lodash';


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class TrafficDatatable extends Component {
    constructor(props) {
        super(props);

        this.gotoChat=this.gotoChat.bind(this);
        this.pickFromQueueFunc=this.pickFromQueueFunc.bind(this);
		this.searchTable=this.searchTable.bind(this);
		
	const sortBy = "name";
    const sortDirection = SortDirection.ASC;
    const sortedList = this._sortList({ sortBy, sortDirection });

    this.state = {
      sortBy,
      sortDirection,
      sortedList,
	  operators:this.props.chatprop.operator
    };
	
	this.searchValue=React.createRef();
	
    }
	
	 searchTable(){
        var table = $('.data-table-traffic-wrapper'+ this.props.id).find('table').DataTable();
        table.search(this.searchValue.current.value).draw();
    }

    pickFromQueueFunc(id){
        this.props.dispatch(pickFromQueue(id));
        this.props.navigate("/chat/"+id);

    }

    gotoChat(id){
        this.props.navigate("/chat/"+id);
    }

    render() {
    return (
      <div style={{"marginTop":"5px","padding":"10px", "height":"88%", "background":"#fff", "overflow":"hidden"}} class="trafficTable">
	  <div className="search_chat has-search ml-0 mb-3">
                    <span className="bx bx-search-alt form-control-feedback"></span>
                    <input className=" chat_input" type="text"
                           onKeyUp={e=>this.searchTable(e)}
                           ref={this.searchValue}
                           placeholder="Search for customer.." />
                </div>
        <AutoSizer>
          {({ height, width }) => (
            <Table
              width={width}
              height={height}
              headerHeight={35}
              rowHeight={40}
              rowCount={this.props.type=="all" ? this.props.chatprop.customers.length : this.props.chatprop.customers.filter(this.props.type).length}
              rowGetter={({ index }) => this.props.type=="all" ? this.props.chatprop.customers[index] : (this.props.type=="chatting" ? this.props.chatprop.customers.filter(this.props.type)[index]:this.props.chatprop.customers.filter(this.props.type).sort((a, b) => (a.chat.pending_time - b.chat.pending_time))[index])}
              //rowGetter={({ index }) => this.props.type=="all" ? this.props.chatprop.customers[index] : this.props.chatprop.customers.filter(this.props.type)[index]}
			  
			  
            >
              <Column label="Customer" dataKey="name" width={280} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			
                            <>
                                <div className="avatar mr-2 float-left" style={{width: '30px', height: '30px'}}>
                                    <div className="letter-avatar" style={getIDForColor(rowData.id)}>{firstLetterSub(rowData.name)}</div>
                                </div>
                                <div className="float-left">{firstLetterText(rowData.name)}<br/>{rowData.email}</div>
                            </>
              )
            } />
              <Column label="Agent" dataKey="name" width={220} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			
              <>
                                {rowData.activity == 'chatting' && typeof rowData.chat.chat_id !== "undefined" && typeof rowData.chat.agent_name !== "undefined" &&
                                                    <span>{rowData.chat.agent_name}</span>
 
                                        }
                            </>
              )
            } />
              <Column label="Actions" dataKey="id" width={200} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
				<>
                                {rowData.activity == 'chatting' && typeof rowData.chat.chat_id !== "undefined" && rowData.chat.agent == this.props.chatprop.operator.id &&
                                                        <a
                                                            className="btn btn-outline-primary btn-md"
                                                            onClick={() => this.gotoChat(rowData.chat.chat_id)}

                                                        >Go To Chat</a>
                                                }
												{rowData.activity == 'chatting' && typeof rowData.chat.chat_id !== "undefined" &&
                                                <SuperViseChatButton rowData={rowData}
                                                                     gotoChat={this.gotoChat}
                                                                     dispatch={this.props.dispatch}
                                                                     chatprop={this.props.chatprop}/>
                                            

                                   
                                    
                                }

                                {rowData.activity == 'queued' && typeof rowData.chat.chat_id !== "undefined" &&
                                            <a
                                                className="btn btn-outline-warning btn-md"
                                                onClick={() => this.pickFromQueueFunc(rowData.chat.chat_id)}

                                            >Pick from queue</a>
                                }
								</>
              )
            } />
              <Column label="Activity" dataKey="activity" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			
                           <>               
                                {rowData.activity == 'browsing' &&
                                    <span className="badge-dot badge badge-light">{firstLetterText(rowData.activity)}</span>
                                }
                                {rowData.activity == 'chatting' &&
                                    <span className="badge-dot badge badge-success">{firstLetterText(rowData.activity)}</span>
                                }
                                {rowData.activity == 'queued' &&
                                    <span className="badge-dot badge badge-warning">{firstLetterText(rowData.activity)} (<TimeAgo  formatter={(value, unit, suffix) => `${value} ${unit}`}
                                                                                                                                   live={true}
                                                                                                                                   date={new Date(rowData.chat.pending_time * 1000)}/>)</span>
                                }

                        </>    
              )
            } />
              <Column label="Site" dataKey="location" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              {rowData.location != null && rowData.location.includes('itemci.com') && 
			  <img src={"Public/images/itemciLogo.png"} style={{ height: '25px', width: 'auto' }} />
			  }
			  
			  {rowData.location != null && rowData.location.includes('oyuncudan.com') &&
			  <img src={"Public/images/oyuncudanLogo.png"} style={{ height: '25px', width: 'auto' }} />
			  }
			  </>
              )
            } />
              <Column label="Country" dataKey="countryName" width={100} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              {typeof rowData.isoCode !== "undefined" && rowData.isoCode !== null && rowData.isoCode !== "" &&
                                <img src={"Public/images/flags/"+rowData.isoCode.toLowerCase()+".png"}/>
			  }
			  
			  {typeof rowData.countryName !== "undefined" &&
                                <span className="ml-1">{rowData.countryName}</span>
			  }
                                
                   </>         
              )
            } />
              <Column label="City" dataKey="cityName" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			
              <>
                                <span>{rowData.cityName} ({rowData.postalCode})</span>
                </>            
              )
            } />
              <Column label="IP" dataKey="ip" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              {cellData}
			  </>
              )
            } />
              <Column label="Browser" dataKey="browser_name" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              {typeof rowData.browser_name !== "undefined" &&
                                <img className="browser_image" src={"Public/images/browser/"+rowData.browser_name.toLowerCase()+"_32x32.png"}/>
			  }
			  
			  {typeof rowData.browser_name !== "undefined" && typeof rowData.browser_version !== "undefined" &&
                                <span className="ml-1">{rowData.browser_name} ({rowData.browser_version})</span>
			  }
                                
                                
                            </>
              )
            } />
              <Column label="Device Type" dataKey="device_type" width={100} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              {cellData}
			  </>
              )
            } />
              <Column label="Os Name" dataKey="os_name" width={150} cellRenderer={
            ({ cellData, rowIndex, dataKey, rowData }) => (
			<>
              
                                <span>{rowData.os_name} ({rowData.os_version})</span>
                     </>       
              )
            } />
            </Table>
          )}
        </AutoSizer>
      </div>
    );
    }
	
  _sortList = ({ sortBy, sortDirection }) => {
    let newList = _.sortBy(this.props.type=="all" ? this.props.chatprop.customers : this.props.chatprop.customers.filter(this.props.type), [sortBy]);
    if (sortDirection === SortDirection.DESC) {
      newList.reverse();
    }
    return newList;
  };

  _sort = ({ sortBy, sortDirection }) => {
    const sortedList = this._sortList({ sortBy, sortDirection });
    this.setState({ sortBy, sortDirection, sortedList });
  };
}
function WithNavigate(props) {
    let navigate = useNavigate();
    return <TrafficDatatable {...props} navigate={navigate} />
}

export default WithNavigate

